import {Box, SimpleGrid, Text} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';

export interface ProduitCaracteristiquesProps {
  ean?: string;
  longueur_utile_mm?: number;
  largeur_mm?: number;
  hauteur_mm?: number;
  poids_net_kg?: number;
}

export const ProduitCaracteristiques: React.FC<
  ProduitCaracteristiquesProps
> = ({ean, longueur_utile_mm, largeur_mm, hauteur_mm, poids_net_kg}) => {
  const {t} = useTranslation();
  const hasDimensions =
    longueur_utile_mm !== undefined ||
    largeur_mm !== undefined ||
    hauteur_mm !== undefined;
  const hasAny =
    ean !== undefined || hasDimensions || poids_net_kg !== undefined;

  if (!hasAny) {
    return null;
  }

  return (
    <Box
      m='20px'
      mt='0px'
      mb='50px'
      p={{base: '10px 20px 0px 20px', md: ''}}
    >
      <Text
        fontSize='xl'
        fontWeight='bold'
        mb={4}
      >
        {t('fiche_produit.caracteristiques')}
      </Text>
      <SimpleGrid
        columns={2}
        spacing={1}
        mt='10px'
        fontSize='sm'
      >
        {ean !== undefined && (
          <>
            <Text>EAN</Text>
            <Text fontWeight='500'>{ean}</Text>
          </>
        )}
        {hasDimensions && (
          <>
            <Text>{t('fiche_produit.dimensions_mm')}</Text>
            <Text fontWeight='500'>
              {[longueur_utile_mm, largeur_mm, hauteur_mm]
                .filter((v): v is number => v !== undefined)
                .join(' × ')}
            </Text>
          </>
        )}
        {poids_net_kg !== undefined && (
          <>
            <Text>{t('fiche_produit.poids_net')}</Text>
            <Text fontWeight='500'>
              {t('fiche_produit.poids_net_kg', {value: poids_net_kg})}
            </Text>
          </>
        )}
      </SimpleGrid>
    </Box>
  );
};
